module.exports = __webpack_public_path__ + "img/evening-usage-active-icon.85378e51.svg";